export const messages = {
  en: {
    role: {
      title: 'Role Management',
      name: 'Name',
      description: 'Description',
      privilege: 'Privilege',
      community: 'Community',
      staff: 'Staff',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteTip: 'Are you sure to delete this role?',
      deleteSuccess: 'Delete successfully',
      saveSuccess: 'Save successfully',
      updateSuccess: 'Update successfully',
      requiredName: 'Please input role name',
      nameLength: 'Role name length must be between 2 and 10',
      descriptionLength: 'Description length must be less than 200',
      communityId: 'Community ID',
      communityName: 'Community Name',
      operation: 'Operation',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      tel: 'Phone',
      email: 'Email',
      address: 'Address',
      sex: 'Gender',
      male: 'Male',
      female: 'Female',
      detail: 'Detail',
      addRole: 'Add Role',
      editRole: 'Edit Role'
    }
  },
  zh: {
    role: {
      title: '角色管理',
      name: '名称',
      description: '描述',
      privilege: '功能授权',
      community: '园区授权',
      staff: '员工关联',
      add: '添加',
      edit: '修改',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      confirmDelete: '确认删除',
      deleteTip: '确定删除该角色吗？',
      deleteSuccess: '删除成功',
      saveSuccess: '保存成功',
      updateSuccess: '更新成功',
      requiredName: '请输入角色名称',
      nameLength: '角色名称长度必须在2位至10位',
      descriptionLength: '角色描述长度不能超过200位',
      communityId: '园区编号',
      communityName: '园区名称',
      operation: '操作',
      staffId: '员工编号',
      staffName: '员工名称',
      tel: '手机号',
      email: '邮箱',
      address: '地址',
      sex: '性别',
      male: '男',
      female: '女',
      detail: '详情',
      addRole: '添加角色',
      editRole: '编辑角色'
    }
  }
}